<script lang="ts" setup>
import type { GetProjectDetailsBuilderResponse } from '@/api';
import PostalAddress from '@/components/PostalAddress.vue';

defineProps<{
  builder: GetProjectDetailsBuilderResponse;
}>();
</script>

<template>
  <section>
    <h2 class="2xs:text-lg xs:text-xl mb-2 text-base font-semibold">{{ builder.category.name }}</h2>
    <div class="mb-4 grid gap-4 rounded-md border-2 border-gray-200 bg-gray-50 p-4">
      <div v-if="builder.logo && builder.logo.length > 0">
        <RouterLink :to="{ name: 'builder', params: { slug: builder.name.toSlug(), builderId: builder.id } }">
          <img :alt="builder.name" :src="builder.logo.resizedToSmall(true)" class="h-16" />
        </RouterLink>
      </div>
      <h5 class="font-semibold tracking-tight">{{ builder.name }}</h5>
      <PostalAddress :address="builder.address" :address-line1-title="builder.addressLine1Title" :address-line2-title="builder.addressLine2Title" class="text-sm" />
    </div>
  </section>
</template>

<style lang="css" scoped></style>
